import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HygieneStaftReportRoutingModule } from './hygiene-staft-report-routing.module';
import { HyginestaftReportComponent } from './hyginestaft-report/hyginestaft-report.component';
import { HygineSidebarComponent } from './hygine-sidebar/hygine-sidebar.component';
import { HyginestaftLinkComponent } from './hyginestaft-link/hyginestaft-link.component';
import { HyginestaftLandingComponent } from './hyginestaft-landing/hyginestaft-landing.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlatpickrModule } from 'angularx-flatpickr';
import { MatIconModule } from '@angular/material/icon';
import { HyginestaftImageDialogComponent } from './hyginestaft-image-dialog/hyginestaft-image-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { AgGridModule } from 'ag-grid-angular';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BuildingImageDataComponent } from './building-image-data/building-image-data.component';
import { BuildingImageDetailsComponent } from './building-image-details/building-image-details.component';
import { BuildingImageDialogComponent } from './building-image-dialog/building-image-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TicketReportsComponent } from './ticketing-reports/ticket-reports/ticket-reports.component';
import { TicketImageDialogComponent } from './ticketing-reports/ticket-image-dialog/ticket-image-dialog.component';
import { HygineCleaningComponent } from './hygine-cleaning/hygine-cleaning.component';
import { HygineCleaningDialogComponent } from './hygine-cleaning-dialog/hygine-cleaning-dialog.component';
import { HygineDayWiseReportComponent } from './hygine-day-wise-report/hygine-day-wise-report.component';
import { HygineDayWiseImageComponent } from './hygine-day-wise-image/hygine-day-wise-image.component';
import { NoAccessComponent } from './no-access/no-access.component';
import { HygineDayWiseFilterdialogComponent } from './hygine-day-wise-filterdialog/hygine-day-wise-filterdialog.component';
import { HygineLiveUpdateComponent } from './hygine-live-update/hygine-live-update.component';
import { HouseKeepingCommandCentreComponent } from './house-keeping-command-centre/house-keeping-command-centre.component';
import { HousekeepingDashboardComponent } from './housekeeping-dashboard/housekeeping-dashboard.component';



@NgModule({
  declarations: [
    HyginestaftReportComponent,
    HygineSidebarComponent,
    HyginestaftLinkComponent,
    HyginestaftLandingComponent,
    HyginestaftImageDialogComponent,
    BuildingImageDataComponent,
    BuildingImageDetailsComponent,
    BuildingImageDialogComponent,
    TicketReportsComponent,
    TicketImageDialogComponent,
    HygineCleaningComponent,
    HygineCleaningDialogComponent,
    HygineDayWiseReportComponent,
    HygineDayWiseImageComponent,
    NoAccessComponent,
    HygineDayWiseFilterdialogComponent,
    HygineLiveUpdateComponent,
    HouseKeepingCommandCentreComponent,
    HousekeepingDashboardComponent,
  ],
  imports: [
    CommonModule,
    HygieneStaftReportRoutingModule,
    AcademicFormModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatDatepickerModule,
    MatInputModule,
    AgGridModule,
    GoogleMapsModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
  ]
})
export class HygieneStaftReportModule { }
